// Simple "come back here after you finish signing up / completing your
// profile" mechanism. The app has no existing redirect-back-after-auth
// pattern — every login/signup flow currently just goes straight to a
// role-based home. sessionStorage (rather than React Router state) is used
// deliberately because the real chain for a brand-new tutor is multiple
// page loads deep: award page → sign up → OTP verify → registration wizard
// → finally back to the award page — state passed via <Navigate> wouldn't
// reliably survive that many hops.
const KEY = "postAuthRedirect";

export const setPostAuthRedirect = (path) => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // sessionStorage unavailable (e.g. private mode) — non-fatal, the
    // affected user just lands on the normal default page instead.
  }
};

export const consumePostAuthRedirect = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    if (path) sessionStorage.removeItem(KEY);
    return path;
  } catch {
    return null;
  }
};
